import { nodeRedApi } from '../../services/axios';

export default async function fetchDispositivos() {
  try {
    const { data } = await nodeRedApi.get('/dispositivos');
    return data;
  } catch (error) {
    console.error("Erro ao buscar dispositivos:", error);
    return [];
  }
}